export const BitcoinConstantsUtil = {
    ACCOUNT_INDEXES: {
        PAYMENT: 0,
        ORDINAL: 1
    }
};
//# sourceMappingURL=BitcoinConstantsUtil.js.map